import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

export const guardsGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const token = localStorage.getItem('token');

  if (token) {
    return true;
  }

  router.navigate(['/admin']);
  return false;
};
